module.exports = __webpack_public_path__ + "static/media/success-rides.39147248.svg";